import React from 'react';
import { Render, ImageBlock, withSrcSets } from '../../platformui';

const ImageBlockWithSrcSets = withSrcSets(ImageBlock);

const SectionBlock = (props) => {
  if (!props.Content) return false;

  const { Image } = props.Content;

  return (
    <div className="c-section-block">
      <div className="c-section-block__bg-area">
        <div className="c-section-block__inner">
          <div className="c-section-block__language-headings">
            <h3>{props.SectionSwedish}</h3>
            <h4>{props.SectionCurrentLang}</h4>
          </div>

          <div className="c-section-block__image-container">
            <Render.Block
              blocks={Image}
              propertyName="Image"
              currentPageProps={props}
              ImageText={false}
            >
              <ImageBlockWithSrcSets UseZoom={false} />
            </Render.Block>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionBlock;
